<template>
    <div class="form-group col-md-6">
        <label for="country" class="mb-0"> {{ $t('country') }} </label>
        <app-input 
            id="country" 
            class="form-control" 
            :placeholder="$t('select_country')"
            type="advance-search-select" 
            fetch-url="/countries/serverside/selectable-name"
            v-model="selected" 
            listValueField="name" 
            :loaded-per-time="5" />
    </div>
</template>

<script>
    export default {
        name: 'countryAddress',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>
